// Mock data for DemoGame homepage

export const mockGameFeatures = [
  {
    id: 1,
    title: "Plant & Harvest Crops",
    description: "Grow diverse crops on your blockchain farm. Each harvest earns you tokens that can be traded or reinvested.",
    icon: "Sprout",
    image: "https://images.unsplash.com/photo-1560493676-04071c5f467b"
  },
  {
    id: 2,
    title: "Raise Farm Animals",
    description: "Collect unique NFT animals. Feed and care for them to produce valuable resources and rare collectibles.",
    icon: "PawPrint",
    image: "https://images.unsplash.com/photo-1751097006268-ae4601fcb117"
  },
  {
    id: 3,
    title: "Advanced Farming Tech",
    description: "Upgrade your farm with cutting-edge technology. Unlock automated systems and boost your productivity.",
    icon: "Cpu",
    image: "https://images.unsplash.com/photo-1524486361537-8ad15938e1a3"
  }
];

export const mockNFTAssets = [
  {
    id: 1,
    name: "Golden Cow NFT",
    rarity: "Legendary",
    description: "Rare collectible that produces premium milk tokens",
    price: "8.5 PIO",
    priceUSD: "$1,275",
    image: "https://images.unsplash.com/photo-1683628005333-3d209d606b0b"
  },
  {
    id: 2,
    name: "Crypto Seed Pack",
    rarity: "Epic",
    description: "Special seeds that grow blockchain-powered crops",
    price: "2.5 PIO",
    priceUSD: "$375",
    image: "https://images.unsplash.com/photo-1639762681485-074b7f938ba0"
  },
  {
    id: 3,
    name: "Smart Tractor",
    rarity: "Rare",
    description: "Automated farming equipment NFT",
    price: "12 PIO",
    priceUSD: "$1,800",
    image: "https://images.unsplash.com/photo-1639762681485-074b7f938ba0"
  },
  {
    id: 4,
    name: "Heritage Barn",
    rarity: "Epic",
    description: "Increases storage capacity for all resources",
    price: "4.8 PIO",
    priceUSD: "$720",
    image: "https://images.unsplash.com/photo-1683628005333-3d209d606b0b"
  }
];

export const mockRoadmap = [
  {
    quarter: "Q1 2026",
    title: "Foundation Launch",
    status: "completed",
    items: [
      "Platform launch on Pio blockchain",
      "Basic farming mechanics",
      "NFT marketplace beta",
      "Community building"
    ]
  },
  {
    quarter: "Q2 2026",
    title: "Expansion Phase",
    status: "in-progress",
    items: [
      "Advanced breeding systems",
      "Seasonal events & rewards",
      "Trading marketplace",
      "Mobile app development"
    ]
  },
  {
    quarter: "Q3 2026",
    title: "Growth & Scaling",
    status: "upcoming",
    items: [
      "Cross-chain integration",
      "Guild system & cooperatives",
      "Tournament mode",
      "Enhanced NFT utilities"
    ]
  },
  {
    quarter: "Q4 2026",
    title: "Metaverse Integration",
    status: "upcoming",
    items: [
      "3D farm visualization",
      "Virtual land ownership",
      "Social farming features",
      "Major partnerships"
    ]
  }
];

export const mockHowToPlay = [
  {
    step: 1,
    title: "Connect Your Wallet",
    description: "Link your Pio-compatible crypto wallet to start your farming journey."
  },
  {
    step: 2,
    title: "Get Your Land",
    description: "Claim your starter farm plot and receive basic farming tools."
  },
  {
    step: 3,
    title: "Plant & Grow",
    description: "Choose seeds, plant crops, and watch them grow in real-time."
  },
  {
    step: 4,
    title: "Harvest & Earn",
    description: "Collect your crops and earn PIO tokens that you truly own."
  }
];

export const mockTokenomics = {
  totalSupply: "10,000,000 PIO",
  marketCap: "$1.5 Billion",
  pioValue: "$150 USD",
  backing: "Gold-backed stable asset",
  distribution: [
    { category: "Play-to-Earn Rewards", percentage: 40, color: "#00FFD1" },
    { category: "Liquidity Pool", percentage: 20, color: "#6FD2C0" },
    { category: "Development", percentage: 15, color: "#4D4D4D" },
    { category: "Marketing", percentage: 10, color: "#FFFFFF" },
    { category: "Team & Advisors", percentage: 10, color: "#00FFD1" },
    { category: "Gold Reserve", percentage: 5, color: "#FFD700" }
  ],
  utilities: [
    "In-game purchases and upgrades",
    "NFT marketplace transactions",
    "Staking for exclusive rewards",
    "Governance voting rights",
    "Gold-backed value stability"
  ]
};

export const mockFAQs = [
  {
    question: "What is PIOFarming Game?",
    answer: "PIOFarming Game is a blockchain-based farming game on the Pio network where you can grow crops, raise animals, and earn real cryptocurrency through gameplay. All your assets are NFTs that you truly own."
  },
  {
    question: "How do I get started?",
    answer: "Simply connect your Pio-compatible wallet, and you'll receive a starter farm for free. No upfront investment required to begin playing."
  },
  {
    question: "What is the PIO token?",
    answer: "PIO is the native token of our game built on the Pio blockchain. You earn PIO by playing the game, which can be traded, staked, or used to purchase in-game items and upgrades."
  },
  {
    question: "Are the NFTs truly mine?",
    answer: "Yes! All game assets including land, animals, and items are NFTs stored on the blockchain. You have complete ownership and can trade them freely on any compatible marketplace."
  },
  {
    question: "Can I play on mobile?",
    answer: "Currently, DemoGame is available on desktop browsers. Mobile app versions for iOS and Android are planned for Q2 2025."
  },
  {
    question: "How do I earn money playing?",
    answer: "You earn PIO tokens by harvesting crops, breeding animals, completing quests, and participating in events. These tokens have real value and can be traded on exchanges."
  }
];

export const mockSocialLinks = {
  twitter: "https://twitter.com/piofarming",
  discord: "https://discord.gg/piofarming",
  telegram: "https://t.me/piofarming",
  medium: "https://medium.com/@piofarming"
};

export const mockStats = {
  totalPlayers: "50,000+",
  totalTransactions: "2.5M+",
  totalValueLocked: "$225M+",
  nftsTraded: "150,000+",
  avgEarnings: "0.5 PIO/day"
};

// Mock wallet connection state
export const mockWalletState = {
  isConnected: false,
  address: null,
  balance: "0"
};

// Mock function to simulate wallet connection
export const mockConnectWallet = () => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({
        success: true,
        address: "0x742d...0bEb",
        balance: "8.35"
      });
    }, 1500);
  });
};

// Mock function to simulate wallet disconnection
export const mockDisconnectWallet = () => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({ success: true });
    }, 500);
  });
};
